import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';

import StockReceiptSupplierList, {
  StockReceiptSupplierListUserData,
} from '../../components/StockReceiptSupplierList/StockReceiptSupplierList.web';

interface ProducePricesProps {
  userData: StockReceiptSupplierListUserData;
  history: RouteComponentProps['history'];
}

interface ProducePricesState {
  userLocalData: StockReceiptSupplierListUserData;
}

const ProducePricesScreen = (props: ProducePricesProps) => (
  <StockReceiptSupplierList
    title={'Produce prices'}
    detailPath={'/web/produce-prices/detail/'}
    userData={props.userData}
    history={props.history}
  />
);

const mapStateToProps = (state: ProducePricesState) => {
  return {
    userData: state.userLocalData,
  };
};

export default connect(mapStateToProps, null)(ProducePricesScreen);
